import _ from 'lodash';
import { Loader } from 'semantic-ui-react';
import React, { useState, useEffect, useCallback} from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';

import Login from './views/Login/Index';
import Dashboard from './views/Dashboard';

import routes from './routes';
import { UserContext } from './context';
import generateListMenu from './daftar_menu.js';
import { check, logout } from './fetcher';
import { NAMA_SEKOLAH, OPTIONS } from './helpers/constant';
import moment from 'moment';

const buildMenu = (list_menu, list_role) => {
	const acl = _.flatMap(list_role, (o) => o.acl).filter(o => !_.isEmpty(o.level));

	let allowed = _.intersectionBy(list_menu, acl, 'id');
	let list_parent = _.chain(allowed).map(o => _.first(o.id.split('#'))).uniq().compact().value();
	list_parent = list_menu.filter(o => _.includes(list_parent, o.id));
	allowed = _.groupBy(allowed, 'parent');
	
	const retval = _.chain(list_parent).map(o => {
		const child = _.get(allowed, o.id, []).map(o => _.omit(o, 'parent'));
		const item = {
			child,
			parent: _.assign({ to: _.chain(child).first().get('to', '').value() }, o),
		};
		return item;
	}).value();
	
	return retval;
}
const buildRoute = (list_route, model) => _.chain(list_route).filter(o => _.includes(o.list_model, model)).value()

const App = () => {
	const [session, setSession]		= useState({});
	const [isLoading, setLoading] = useState(true);

	const checkUser = useCallback(async () => {
		setLoading(true);
		let session = {};
		session = _.get(await check(), 'result', {});

		session = {
			is_login: false,
			sekolah: {
				nama: "SMA Negeri 6 Surakarta",
				kode: "sman6ska",
				perbaikan: false
			},
			roles: [
				{ _id: "role-murid", nama: "murid", tipe: "model", acl: [
					{ _id: "keluar", level: "RU", id: "PROFIL#KELUAR" },
					{ _id: "pengumuman", level: "R", id: "PENGUMUMAN" },
				] }
			],
			model: 'murid',
			user: {
				nama: "NAMA MURID",
				nis: "SAMPLE NIS",
				nisn: "SAMPLE NISN",
				kelas_kode: "SAMPLE KODE",
				kelas_tingkat: "XII",
			},
			tanggal_kelulusan: moment(`2021-04-29T13:52:00`).toDate(),
			...session,
		};

		const { roles, user } = session;
		const nama_sekolah = _.get(session, 'sekolah.nama', "");
		
		const list_acl 	= _.flatMap(roles, (o) => o.acl).filter(o => !_.isEmpty(o.level));
		const map_acl 	= _.chain(list_acl).groupBy("id").mapValues(arr => _.assign(
			{}, _.last(arr), 
			{ level: _.chain(arr).reduce((sum, o) => sum + _.get(o, 'level', ''), '').split('').uniq().compact().value().join('') },
		)).value();	
		_.set(session, "list_acl", list_acl);
		_.set(session, "map_acl", map_acl);

		if (session.is_login) {
			const { nama } = user;
			const all_menu = generateListMenu({
				nama,
				handleLogout: async () => {
					await logout();
					await checkUser();
				},
			});
			const list_menu = buildMenu(all_menu, session.roles);
			const list_route = buildRoute(routes, session.model);

			console.log("all_menu", all_menu);
			console.log("list_menu", list_menu);
			console.log("list_route", list_route);
			_.set(session, "list_route", list_route);
			_.set(session, "list_menu", list_menu);
			_.set(session, "list_warna", OPTIONS.OPTS_COLOR);
		}

		if (_.isEmpty(nama_sekolah)) {
			_.set(session, "sekolah.nama", NAMA_SEKOLAH);
		} 
		setSession(session);
		return setLoading(false);
	}, []);

	useEffect(() => {
		// console.log('Get user data');
		checkUser();
	}, [checkUser]);
	
	return (<UserContext.Provider value={_.assign({ checkUser }, session)}>
		<BrowserRouter>
			{isLoading ?  <Loader/> : <Switch>
				<Route path='/login' component={Login} />
				{/* <Route path='/reset-password' component={ResetPassword} /> */}
				<Route path='/' component={Dashboard} />
			</Switch>}
		</BrowserRouter>
	</UserContext.Provider>);
};

export default App;